/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileSync = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V22H4zm2 2v16h12V9h-5V4zm9 1.414V7h1.586z" />
        <path d="m10 7.586 3.207 3.207-1.414 1.414-.793-.793V15H9v-3.586l-.793.793-1.414-1.414zm4 11.828-3.207-3.207 1.414-1.414.793.793V12h2v3.586l.793-.793 1.414 1.414z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileSync as FileSync };
